import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { connect } from 'react-redux';
import { imagesCDNUrl, podcastTypes, websiteUrl } from '../../lib/utils';
import memoizeOne from 'memoize-one';
import AppSideScroll from './AppSideScroll';
import { colors, spacing } from '../../lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppCustomLink from './AppCustomLink';
import { Modal } from 'antd';
import Interests from './Interests';
import { fetchBlogLists, fetchFeaturedLists } from '../../actions';
import { LazyLoadImage } from 'react-lazy-load-image-component';

class BlogListsMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // visible: false
        }
    }

    componentDidMount() {
        this.props.callParent();
    }

    render() {
        const { featuredLists, settingsState, genreId } = this.props;
        console.dir(featuredLists);
        console.dir(settingsState);
        console.dir(settingsState.featuredBgColor);
        return (
            <div>
                <AppSideScroll title={genreId == '11' ? 'Inspiring Collections' : 'Curated Collections'}>
                    {
                        featuredLists.map((genreMap, index) =>
                            <div key={index}>
                                <a href={`${websiteUrl}/blog/${genreMap['slug']}`} target='_blank' rel="noopener noreferrer">
                                    <div
                                        style={{
                                            marginRight: `${spacing('lg')}`,
                                            // padding: '1em 1.5em', borderRadius: '8px', 
                                            width: '240px',
                                            //  height: '100px'
                                        }}>
                                        {/* <FontAwesomeIcon style={{ color: 'white', fontSize: '1.75em', marginBottom: '4px' }} icon={genreMap['icon']} /> */}
                                        <LazyLoadImage
                                            alt={genreMap['title']}
                                            // height={podcastImgSize} // use normal <img> attributes as props
                                            width='100%'
                                            // height='100%'
                                            src={imagesCDNUrl + 'collections/' + genreMap['image']}
                                        // src={`${websiteUrl}/blog-images/small/${genreMap['image']}`} 
                                        />
                                    </div>
                                    {/* <p style={{ marginTop: '8px', marginBottom: '1em', marginRight: `${spacing('lg')}` }}>{genreMap['title']}</p> */}
                                </a>
                            </div>
                        )
                    }
                </AppSideScroll>
            </div>
        )
    }
}

BlogListsMain.propTypes = {
    genreId: PropTypes.any,
    settingsState: PropTypes.any,
    callParent: PropTypes.any,
    featuredLists: PropTypes.any,
}

class BlogLists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // visible: false
        }
    }

    callParent = () => {
        const { genreId } = this.props;
        console.dir(genreId);
        this.props.fetchBlogLists(genreId);
    }

    render() {
        const { genreId, blogLists, settingsState } = this.props;
        console.dir(blogLists);
        const blogListsFin = (blogLists || []).filter(el => (el.genreIds || []).includes(genreId));
        console.dir(blogListsFin);
        // if (!userInterests) {
        //     return <div></div>
        // }

        return <BlogListsMain settingsState={settingsState} genreId={genreId}
            callParent={this.callParent} featuredLists={blogListsFin} />
    }
}

BlogLists.propTypes = {
    genreId: PropTypes.string.isRequired,
    userInterests: PropTypes.object,
    settingsState: PropTypes.object,
    fetchBlogLists: PropTypes.func,
    blogLists: PropTypes.any,
}

const mapStateToProps = (state) => {
    return {
        userInterests: state.userInterests,
        blogLists: state.blogLists,
        settingsState: state.settingsState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchBlogLists: bindActionCreators(fetchBlogLists, dispatch),
    }
};

// export default withRedux(initStore, null, null)(Home);
// export default compose(
//   withRedux(initStore, null, null),
//   connect(mapStateToProps, mapDispatchToProps)
// )(Home);

export default connect(mapStateToProps, mapDispatchToProps)(BlogLists);